import React from 'react';
import NetInfo, { useNetInfo } from '@react-native-community/netinfo';
import { NoInternetScreen } from './NoInternetScreen';

export const NetworkStatusListener: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const netInfo = useNetInfo();

  if (netInfo.isConnected === false) {
    return <NoInternetScreen onRetry={async () => { await NetInfo.fetch(); }} />;
  }

  return <>{children}</>;
};
